import {customElement} from "lit/decorators.js";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";
import {clickEventAlreadyHandledByChild} from "../../../common/utils/events";
import Styles from "./inlineModalDialogContentLink.lit.scss";

@customElement("eop-inline-modal-dialog-content-link")
export class EopInlineModalDialogContentLink extends DialogAnchorTemplateContent {

    public static readonly styles = Styles;

    public connectedCallback(): void {
        super.connectedCallback();
        this.addEventListener("click", (e: Event) => {
            if (clickEventAlreadyHandledByChild(e, this)) {
                return;
            }
            this.openDialog(e);
        });
        this.addEventListener("keydown", (e: Event) => {
            if (clickEventAlreadyHandledByChild(e, this)) {
                return;
            }
            this.openDialog(e);
        });
    }
}